import {
	connect
} from 'react-redux'
import GearModelEditComponent from '../components/GearModelEditComponent.jsx';
import {
	changeGearModelValue,
	addGearModel,
	editGearModel,
	findAllModelSizeTypes
} from '../actions';

const mapStateToProps = (state) => ({
	gearModel: state.getIn(['gearModelReducer', 'gearModel']),
	gearModelValidation: state.getIn(['gearModelReducer', 'gearModelValidation']),
	alertStyle: state.getIn(['gearModelReducer', 'alertStyle']),
	alertMessage: state.getIn(['gearModelReducer', 'alertMessage']),
	forInsert: state.getIn(['gearModelReducer', 'forInsert']),
	allSizeTypes: state.getIn(['gearModelReducer', 'allSizeTypes']),

	activePage: state.getIn(['gearModelListReducer', 'activePage']),
	itemPerPage: state.getIn(['gearModelListReducer', 'itemPerPage'])
})

const mapDispatchToProps = (dispatch) => ({
	editItem: (gearModel, pagingData, forInsert) => {
		if (forInsert) {
			dispatch(addGearModel(gearModel, pagingData));
		} else {
			dispatch(editGearModel(gearModel, pagingData));
		}
	},
	setValue: (id, value) => {
		dispatch(changeGearModelValue({
			id: id,
			value: value
		}))
	},
	findAllModelSizeTypes:() => {
		dispatch(findAllModelSizeTypes());
	}
})

const GearModelEditContainer = connect(
	mapStateToProps,
	mapDispatchToProps
)(GearModelEditComponent)

export default GearModelEditContainer;


// WEBPACK FOOTER //
// ./src/containers/GearModelEditContainer.jsx